import { ComputedRef, InjectionKey } from 'vue';
import type { AdpDocument } from '@/types';
import type {
  InsightAxisType,
  InsightPrefillPromptGenerationStatus,
  InsightSourceKey,
  InsightTrackingPageName,
} from '@/types/insights';

export interface ResolvedInsightSource {
  position: number;
  document: AdpDocument;
  insightSourceId: number;
}

export interface InsightSourcesContext {
  resolveSources: (keys: InsightSourceKey[]) => ResolvedInsightSource[];
}

export const InsightSourcesContextKey: InjectionKey<InsightSourcesContext> =
  Symbol('InsightSourcesContext');

export interface InsightPrefillStatusesContext {
  resolveStatus: (
    uuid: string,
  ) => InsightPrefillPromptGenerationStatus | undefined;
}

export const InsightPrefillStatusesContextKey: InjectionKey<InsightPrefillStatusesContext> =
  Symbol('InsightPrefillStatusesContext');

export const InsightIdKey: InjectionKey<ComputedRef<number | null>> =
  Symbol('InsightId');

export const InsightDateKey: InjectionKey<ComputedRef<string | null>> =
  Symbol('InsightDate');

export interface InsightTrackingContext {
  pageName: InsightTrackingPageName;
  insightId: number;
  axisId: number;
  axisName: InsightAxisType;
}

export const InsightTrackingContextKey: InjectionKey<InsightTrackingContext> =
  Symbol('InsightTrackingContext');

export const InsightPageNameKey: InjectionKey<InsightTrackingPageName> =
  Symbol('InsightPageName');

export const InsightAxisRetryKey: InjectionKey<() => Promise<void> | void> =
  Symbol('InsightAxisRetry');
